// 5.49.1 stacking layers shared by the top bar and the "HealthSherpa in use" strip (one place, so they can't drift).
// The lock strip (HsLockStrip) sits at Z_LOCK_STRIP: above the calendar Today card (Z_CALENDAR_CARD, 950).
// Every top-bar dropdown / popup (Telecom ▾, + New ▾, Admin ▾, the user menu, the quick-codes drawer) must open ABOVE
// the strip, so its click-away layer and the menu itself sit higher. Modals (e.g. the 3000 "HealthSherpa in use" modal)
// stay above all of these.
export const Z_LOCK_STRIP = 960;
export const Z_TOPBAR_MENU_AWAY = 970;   // the transparent click-away layer behind an open top-bar menu
export const Z_TOPBAR_MENU = 980;        // the open menu / drawer
// 5.50.0 the calendar "Today" card (Main + HealthSherpa pages): above normal page content and the HealthSherpa plan drawer,
// BELOW the lock strip (so it never covers the strip's Clear button) and below the top-bar menus and every modal.
export const Z_CALENDAR_CARD = 950;
